<template>
	<fragment>
		<common-header
			subname="강의지원"
			name="소속기관 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:searchbox="true"
			@keywordChanged="keywordChanged"
		></common-header>

		<section ref="container" class="container">
			<ctrl-filter listName="소속기관 목록"></ctrl-filter>

			<div class="container-fiuld">
				<div class="btn-group-box clearfix">
					<div class="btn-group pull-left clearfix">
						<!--
						<div class="select pull-left m-r-5">
							<a class="btn btn-red round" @click="onUnify">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20"
									viewBox="0 0 20 20">
									<path id="Integration" class="integration"
										d="M520.385,277H509.6a1.613,1.613,0,0,0-1.616,1.606v4.344h-4.369A1.612,1.612,0,0,0,502,284.556v10.727a1.612,1.612,0,0,0,1.615,1.606h8.113c-0.01-.049-0.022-0.1-0.028-0.146l-0.222-1.89h-7.431v-9.867h3.937v4.345a1.613,1.613,0,0,0,1.616,1.607h1.421l-0.239-2.036h-0.75v-3.916h3.938v1.229l2.047,1v-2.657a1.613,1.613,0,0,0-1.616-1.606h-4.37v-3.914h9.922V288.9h-0.472l1.991,0.971a1.826,1.826,0,0,1,.33.213,1.581,1.581,0,0,0,.2-0.755V278.606A1.612,1.612,0,0,0,520.385,277Zm0.484,14.09-8.194-3.995a0.475,0.475,0,0,0-.479.037,0.468,0.468,0,0,0-.2.437l1.055,9.017a0.467,0.467,0,0,0,.338.395,0.45,0.45,0,0,0,.13.019,0.472,0.472,0,0,0,.367-0.176l2.757-3.433,4.169-1.438A0.467,0.467,0,0,0,520.869,291.09Z"
										transform="translate(-502 -277)" />
								</svg> 기관통합
							</a>
						</div>
						-->
					</div>

					<div class="btn-group pull-right clearfix">
						<select class="form-control round pull-left m-r-5" @change="onPageSize">
							<option value="10">10개씩 보기</option>
							<option value="30">30개씩 보기</option>
							<option value="50">50개씩 보기</option>
						</select>
						<select class="form-control round pull-left m-r-5" @change="onOrderBy">
							<option :value="null">정렬</option>
							<option value="AGENCY_NAME ASC">이름 오름차순</option>
							<option value="AGENCY_NAME DESC">이름 내림차순</option>
							<option value="REG_DATE ASC">등록일 오름차순</option>
							<option value="REG_DATE DESC">등록일 내림차순</option>
						</select>
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" @click="downloadExcel">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 전체 내려받기
							</a>
						</div>
					</div>
				</div>

				<table class="table2 table-hover m-t-10 text-center">
					<thead>
						<tr class="bg-lightgray">
							<th>
								<input id="table-allcheck" class="checkbox" type="checkbox"
									:checked="isCheckedAll" @change="checkAllAgency()">
								<label for="table-allcheck">체크버튼</label>
							</th>
							<th>기관코드</th>
							<th>분류</th>
							<th>기관명</th>
							<th>소속회원수</th>
							<th>관리</th>
						</tr>
					</thead>
					<tbody v-for="( agency, agencyIndex ) in agencyList" :key="hash(agency)">
						<tr class="margin">
							<td colspan="6"></td>
						</tr>
						<tr :class="clickedAgency === agency ? 'on' : ''" @click="onClickInstitution(agency)">
							<td>
								<input :id="`table-check3-${hash(agency)}`" v-model="agency.isChecked"
									class="checkbox" type="checkbox">
								<label :for="`table-check3-${hash(agency)}`">체크버튼</label>
							</td>
							<td>
								{{agency.agencyCode}}
							</td>
							<td>{{agency.agencyCategory}}</td>
							<td>
								{{agency.agencyName}}
							</td>
							<td>
								NO DATA
							</td>
							<td>
								<a class="modify m-r-10" @click="showModifyAgencyModal(agency)">수정</a>
								<a class="del" @click="onDeleteAgency(agencyIndex)">삭제</a>
							</td>
						</tr>
					</tbody>
				</table>

				<ctrl-pagination
					:currentPage="offset / pageSize + 1"
					:pageSize="parseInt(pageSize)"
					:totalCount="totalCount"
					:key="hash({pageSize, offset, totalCount})"
					@pageChanged="onPageChanged"
				></ctrl-pagination>
			</div>

			<ctrl-institution-summary v-if="clickedAgency" ref="scrollableSummary" :agency="clickedAgency"
				@modifyAgency="showModifyAgencyModal" @showAgencyMembers="showAgencyMembers()"></ctrl-institution-summary>
		</section>

		<common-footer></common-footer>

		<modal-institution-register :config="modals.ModalInstitutionRegister"  @refresh="getInstitutionData()" @alert="onAlert"
			@close="modals.ModalInstitutionRegister.show = false" @onModified="(agency) => {console.log(agency)}"
			:key="hash(modals.ModalInstitutionRegister)"></modal-institution-register>

		<modal-institution-modify :config="modals.ModalInstitutionModify" @refresh="getInstitutionData()" @alert="onAlert"
			@close="modals.ModalInstitutionModify.show = false" :key="hash(modals.ModalInstitutionModify)"></modal-institution-modify>

		<modal-institution-excel :config="modals.ModalInstitutionExcel" @close="modals.ModalInstitutionExcel.show=false;" @refresh="getInstitutionData" :key="hash(modals.ModalInstitutionExcel)"></modal-institution-excel>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false"
			@no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>

		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnScrollable from '../mixins/fnScrollable.js'

import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CtrlFilter from '../components/CtrlFilter.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import CtrlInstitutionSummary from '../components/CtrlInstitutionSummary.vue'

import ModalAlert from '../modals/ModalAlert.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalInstitutionRegister from '../modals/ModalInstitutionRegister.vue'
import ModalInstitutionModify from '../modals/ModalInstitutionModify.vue'
import ModalInstitutionExcel from '../modals/ModalInstitutionExcel.vue'

import axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트명
	name: "ViewInstitutionList",
	mixins: [fnScrollable, fnAdjustHeight],

	mounted: function() {
		this.getInstitutionData();
	},
	// 이 컴포넌트 안에서 사용할 자식컴포넌트
	components: {
		CommonHeader,
		CommonFooter,
		CtrlFilter,
		CtrlPagination,
		CtrlInstitutionSummary,
		ModalAlert,
		ModalConfirm,
		ModalInstitutionRegister,
		ModalInstitutionModify,
		ModalInstitutionExcel
	},

	// 이 컴포넌트 내부에서 사용되는 데이터
	data: function() {
		return {
			modals: {
				ModalAlert: ModalAlert.default(),
				ModalConfirm: ModalConfirm.default(),
				ModalInstitutionRegister: ModalInstitutionRegister.default(),
				ModalInstitutionModify: ModalInstitutionModify.default(),
				ModalInstitutionExcel: ModalInstitutionExcel.default()
			},
			menus: [ // 서브메뉴
				{name:'소속기관 관리',link:"",selected:true},
			],
			buttons: [ // 헤더버튼
				{name:'기관등록',fn:this.onInstitutionRegister},
				{name:'기관 일괄등록',fn:this.onInstitutionRegisterExcel}
			],

			agencyList: [], // 아이템 목록
			clickedAgency: null,

			// 검색 조건
			offset: 0,
			keyword: "",
			orderBy: null,
			pageSize: 10,
			filterList: [],

			// 필터링된 회원수
			totalCount: 0
		}
	},

	// 이 컴포넌트 내부에서 사용되는 기능
	methods: {
		keywordChanged: function(keyword) {
			this.keyword = keyword;
			this.getInstitutionData();
		},
		getInstitutionData: async function() {
			const { offset, keyword, pageSize, orderBy, filterList } = this;
			try {
				const { data } = await axios.post(`${server.addr()}`+server.api.AGENCY, {
					offset, keyword, pageSize, orderBy, filterList
				});

				this.agencyList = data.list ? data.list : [];
			} catch(e) {
				this.modals.ModalAlert.msg = "통신 오류! 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			}
		},
		onInstitutionRegister: function() {
			this.modals.ModalInstitutionRegister.show = true;
		},
		onInstitutionRegisterExcel: function() {
			this.modals.ModalInstitutionExcel.show = true;
		},
		onUnify: function() {
		},
		onPageSize: function($event) {
			const { value }  = $event.target;

			this.pageSize = parseInt(value);
		},
		onOrderBy: function($event) {
			this.orderBy = $event.target.value;
		},
		// 기관 클릭 시
		onClickInstitution: function(agency) {
			this.clickedAgency = agency;
		},
		// 전체 기관 체크
		checkAllAgency: function() {
			const isCheckedAll = this.agencyList.reduce((prev, curr) => (
				prev && curr.isChecked ? true : false
			), true); // 전체가 선택되어있는지 검색

			this.agencyList.forEach(member => {
				this.$set(member, "isChecked", !isCheckedAll);
			});
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;

			this.getInstitutionData();
		},
		// 에이전시 수정 모달 표시
		showModifyAgencyModal: function(agency) {
			this.modals.ModalInstitutionModify.targetAgency = agency;
			this.modals.ModalInstitutionModify.show = true;
			// TODO 수정모달
		},
		// 기관 삭제
		onDeleteAgency: function (agencyIndex) {
			this.modals.ModalConfirm.msg = "정말로 삭제 하시겠습니까?";
			this.modals.ModalConfirm.show = true;

			this.modals.ModalConfirm.btnYes.fn = async () => {
				this.modals.ModalConfirm.show = false;

				try {
					await axios.delete(`${server.addr()}/sys/agency/${this.agencyList[agencyIndex].agencyId}`);
					// 리스트데이터 다시 받기
					this.getInstitutionData();
					// 완료 모달
					this.modals.ModalAlert.msg = "삭제 처리 되었습니다.";
					this.modals.ModalAlert.show = true;
				} catch (e) {
					this.modals.ModalAlert.msg = "통신 오류! 잠시 후 다시 시도해주세요.";
					this.modals.ModalAlert.show = true;
				}
			}
		},
		// showAgencyMembers
		showAgencyMembers: function() {
			// TODO: 에이전시 맴버 확인
		},
		onAlert: function(msg) {
			this.modals.ModalAlert.show = true;
			this.modals.ModalAlert.msg = msg;
		},
		downloadExcel: function() {
			const { keyword, orderBy, filterList } = this;

			// eslint-disable-next-line
			console.log("여기 오는지 확인 1111")

			axios.post(server.addr()+server.api.AGENCY_EXCEL, {
				offset:0, keyword, orderBy, filterList, pageSize:5000000
			}).then( response => {
				// eslint-disable-next-line
				console.log("여기 오는지 확인 22222")
				window.open(server.addr()+"/download/"+response.data, "", "");
			})
		}
	},

	computed: {
		// 전체가 선택되어 있는지 확인하는 함수
		isCheckedAll: function() {
			const isCheckedAll = this.agencyList.reduce((prev, curr) => (
				prev && curr.isChecked ? true : false
			), true); // 전체가 선택되어있는지 검색

			return isCheckedAll;
		}
	}
}
</script>

<style>
.integration {
	fill: #fff;
	fill-rule: evenodd;
}
</style>